/* eslint-disable @typescript-eslint/no-explicit-any */
export const validateRequired = (value: any, fieldName: string): string => {
    if (!value || (typeof value === "string" && value.trim() === "")) {
      return `${fieldName} is required`;
    }
    return "";
  };

  export const validateNumber = (value: any, fieldName: string, min = 0): string => {
    if (value !== undefined && value !== null && value !== "") {
      const num = Number(value);
      if (isNaN(num)) {
        return `${fieldName} must be a valid number`;
      }
      if (num < min) {
        return `${fieldName} must be at least ${min}`;
      }
    }
    return "";
  };

   export const validateDateRange = (fromDate: string, toDate: string): string => {
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      if (from > to) {
        return "End date must be after start date";
      }
    }
    return "";
  };

  export const validateAge = (age: string): string => {
    if (age) {
      const ageNum = Number(age);
      if (isNaN(ageNum) || ageNum < 0 || ageNum > 150) {
        return "Please enter a valid age (0-150)";
      }
    }
    return "";
  };

  export const validateEmail = (email: string): string => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      return 'Please enter a valid email address';
    }
    return '';
  };

  export const validateDate = (value: string, fieldName: string, options: { allowFuture?: boolean } = {}): string => {
    if (!value) return `${fieldName} is required`;
    const date = new Date(value);
    if (isNaN(date.getTime())) return `${fieldName} is invalid`;
    if (!options.allowFuture && date > new Date()) {
      return `${fieldName} cannot be in the future`;
    }
    return "";
  };